module.exports = __webpack_public_path__ + "static/media/calculator-fill.ab6a1c66.svg";